export const MONTH_ARRAY = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

export const MEASURE_X = 10500;
export const MEASURE_Y = 2800;
